import * as React from 'react';
import { useCallback } from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import cn from 'classnames';
import Checkbox from '../../../BaseComponents/Checkbox';
import { useTheme } from '../../../theme';
import { useToggleable } from '../../../hooks';
import { SubsidyType } from '@websky/graphql';
import { initI18n } from '../../../utils';
import { useTranslation } from 'react-i18next';
import icons from './icons';
initI18n('Subsidies');
var SubsidiesSelector = function (props) {
    var _a;
    var _b, _c;
    var theme = useTheme('Subsidies').SubsidiesSelector;
    var _d = useToggleable(false), setActive = _d.setOpen, isActive = _d.isOpen;
    var t = useTranslation('Subsidies').t;
    var handleChange = useCallback(function (e) {
        props.onChange(e);
        setActive(e.target.checked);
    }, [props.onChange]);
    var subsidyKey = "".concat(props.type).concat(props.type === SubsidyType.Other ? "_".concat(props.id) : '');
    var icon = icons[subsidyKey];
    var title = t("program_".concat(subsidyKey));
    var description = t("description_".concat(subsidyKey));
    return (React.createElement(FormGroup, { className: cn(theme.container, (_a = {},
            _a[theme.active] = props.isSelected,
            _a[theme.disabled] = props.disabled,
            _a), props.className) }, (_c = (_b = props.content) === null || _b === void 0 ? void 0 : _b.call(props, {
        isActive: isActive,
        icon: icon,
        disabled: props.disabled,
        type: props.type,
        title: title,
        onChange: handleChange
    })) !== null && _c !== void 0 ? _c : (React.createElement(FormControlLabel, { disabled: props.disabled, className: theme.label, classes: { label: theme.label }, control: React.createElement(Checkbox, { className: theme.checkbox, checked: props.isSelected, onChange: handleChange }), label: React.createElement("div", { className: theme.subsidyInfo },
            React.createElement("span", { className: theme.text },
                React.createElement("div", { className: theme.title }, title),
                React.createElement("div", { className: theme.description }, description)),
            icon) }))));
};
export default SubsidiesSelector;
